/**
 * @param roiCalculatorDocument
 * @return {undefined | HTMLButtonElement}
 */
module.exports = function getTopDownloadPdfButton(roiCalculatorDocument) {
    const buttons = roiCalculatorDocument.querySelectorAll('#open-report');

    if (buttons.length > 0) {
        return buttons[0];
    }
}
